const ALL_DENIED = {
  analytics_storage: "denied",
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  functionality_storage: "denied",
  personalization_storage: "denied",
};

export function applyConsent({ accepted = [] } = {}) {
  document.dispatchEvent(
    new CustomEvent("sf:consent-updated", { detail: { accepted } })
  );

  if (typeof window.gtag !== "function") return;

  const accept = new Set(accepted);
  const update = { ...ALL_DENIED };

  if (accept.has("analytics")) {
    update.analytics_storage = "granted";
  }
  if (accept.has("marketing")) {
    update.ad_storage = "granted";
    update.ad_user_data = "granted";
    update.ad_personalization = "granted";
  }
  if (accept.has("functional")) {
    update.functionality_storage = "granted";
    update.personalization_storage = "granted";
  }

  window.gtag("consent", "update", update);
}
